/* eslint-disable @typescript-eslint/naming-convention */

import { formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DownloaderService } from '../../shared/download/downloader.service';
import { JsonHttpService } from '../../shared/http/json-http.service'

@Injectable({
    providedIn: 'root'
})
export class DistributionExportService {

    constructor(
        private http: JsonHttpService,
        private downloaderService: DownloaderService    ) {
    }

    async exportDistributions(distributionIds: number[], includeArtifacts: boolean): Promise<any> {
        const filename = `DistributionExport_${formatDate(new Date(), 'yyyyMMdd_HHmmss', 'en')}`;
        const options = { params: new HttpParams().set('filename', filename) };
        options.params = options.params.set('includeArtifacts', includeArtifacts.toString());
        const distributionExportOptions = {
            DistributionIds: distributionIds,
        };
        const token = await this.http.post('/api/distribution/export/export', distributionExportOptions, options, true).toPromise();
        return this.downloaderService.downloadFile(token);
    }
}
